import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { Button } from "../reusable-components";
import { useTranslation } from "react-i18next";

interface LoginDialogProps {    
    open: boolean
    onClose: () => void
}

const handleClose = (props: LoginDialogProps) => {
    props.onClose();
}

const LoginDialog: React.FC<LoginDialogProps> = (props) => {

    const { t } = useTranslation();

    return (
        <Dialog open={props.open} sx={{ alignItems: "flex-start", "& .MuiDialog-container": { alignItems: "flex-start" }, "& .MuiDialog-paper": { marginTop: "20px" } }}>
            <DialogContent>
                <Typography>{t('login_dialog')}</Typography>
            </DialogContent>
            <DialogActions sx={{justifyContent:"center"}}>
                <Button onClick={() => handleClose(props)} >
                    {t('login')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default LoginDialog
